<template>
  <div id="app-print">
    <div class="print-box">
      <div class="print-top">
        <h3 :class="{'animated': classHide, 'fadeInLeft': classHide}">爱眼足迹</h3>
        <div :class="{'border-box':classShow, 'animated': classHide, 'fadeInUpBig': classHide}"></div>
      </div>
      <div class="print-bottom">
        <div :class="{'print-left':classShow, 'animated': classHide, 'fadeInLeft': classHide}">
          <div class="map-box">
            <!-- <div
              :class="className"
              :id="id"
              :style="{height:height,width:width,'margin-left': '-460px','margin-top':'-48px'}"
              ref="myEchart"
            ></div>-->
            <draw-map></draw-map>
          </div>
          <!-- <img src="../../assets/images/map.png" alt> -->
        </div>
        <div :class="{'print-right':classShow, 'animated': classHide, 'fadeInRight': classHide}">
          <div class="r-top">
            <div class="top-title">
              <div class="title-box">
                <span>捐赠信息</span>
                <i>数据截至{{year}}年底</i>
              </div>
              <!-- <p>更多</p> -->
            </div>
            <ul>
              <li>
                <b style="font-size: 28px">{{currentSum}}</b>
                <span>元</span>
                <p>累计公益收入总额</p>
              </li>
              <li>
                <b style="font-size: 28px">{{webInfo.information[0].money}}</b>
                <span>{{webInfo.information[0].unit}}</span>
                <p>{{webInfo.information[0].title}}</p>
              </li>
            </ul>

            <ul style="margin-top:20px">
              <li>
                <b style="font-size: 28px">{{lastSum}}</b>
                <span>元</span>
                <p>上一年度收入总额</p>
              </li>
              <li>
                <b style="font-size: 28px">{{lastSpend}}</b>
                <span>元</span>
                <p>上一年度公益支出总额</p>
              </li>
            </ul>
            <ul style="margin-top:20px">
              <li v-if="index>0" v-for="(item,index) in webInfo.information"
                  :key="index"
                  class="donate-list"
                  style="padding: 0 10px">
                <b style="font-size:28px">{{item.money}}</b>
                <span>{{item.unit}}</span>
                <p>{{item.title}}</p>
              </li>
            </ul>
          </div>
          <div class="r-bottom">
            <div class="b-top">
              <h5>捐赠名录</h5>
              <p style="cursor:pointer"
                 @click="goDonation">更多</p>
            </div>
            <vue-seamless-scroll :data="DonationList"
                                 :class-option="optionSingleHeight"
                                 class="seamless-warp">
              <ul class="item_box">
                <li v-for="(item,index) in DonationList"
                    :key="index"
                    :title="item.display_name">
                  <h5>{{item.display_name}}</h5>
                  <p>{{setMoneyFormat(item.money)}}</p>
                  <span>{{item.date_time}}</span>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import nationName from "../../assets/js/nation.js"; //世界国家的名字
import "../../../node_modules/echarts/map/js/world.js"; // 引入中国地图数据
import DrawMap from "./map";
export default {
  components: {
    DrawMap
  },
  props: {
    className: {
      type: String,
      default: "yourClassName"
    },
    id: {
      type: String,
      default: "yourID"
    },
    width: {
      type: String,
      default: "1020px"
    },
    height: {
      type: String,
      default: "570px"
    }
  },
  data () {
    return {
      year: "",
      nationName,
      currentSum: "",
      lastSum: "",
      lastSpend: "",
      classHide: false,
      classShow: true,
      DonationList: [],
      option: [],
      echart_min: 0,
      echart_max: 0,
      inRangeColor: [],
      dataRangeData: {},
      webInfo: {}
    };
  },

  mounted () {
    // window.addEventListener("scroll", this.isElementInViewport, true);

    this.$db.post(this.$db.config.indexDonationList, {}).then(res => {
      if (res && res.code == 200) {
        if (res.data.list.data && Object.keys(res.data.list.data).length > 0) {
          this.DonationList = res.data.list.data;
        }
        this.year = res.data.year;
        this.currentSum = this.setMoneyFormat(res.data.sum);
        this.lastSum = this.setMoneyFormat(res.data.lastyear_in);
        this.lastSpend = this.setMoneyFormat(res.data.lastyear_out);
      }
    });

    this.$db.post(this.$db.config.indexMapData, {}).then(res => {
      this.option = res.data;

      this.option.forEach((item, index) => {
        this.echart_max =
          item.hospital > this.echart_max ? item.hospital : this.echart_max;
      });
      if (this.echart_max == this.echart_min && this.echart_max == 0) {
        this.inRangeColor = {};
      } else {
        this.inRangeColor = { color: ["#ff6600", "#e60012", "#D71518"] };
      }
      this.dataRangeData = {
        x: "-500",
        y: "-500",
        min: this.echart_min,
        max: this.echart_max,
        text: ["High", "Low"],
        realtime: false,
        calculable: false,
        inRange: this.inRangeColor
      };

      this.initChart();
    });
  },
  // destroyed() {
  //   window.removeEventListener("scroll", this.isElementInViewport); //监听页面滚动事件
  // },
  methods: {
    isElementInViewport () {
      let el = document.getElementById("app-print");
      // let top = el.offsetTop;
      let lTop = document.documentElement.clientHeight;
      let b = top + 50 - lTop;
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > b) {
        this.classHide = true;
      } else {
        // this.classHide = false;
      }
    },
    //当前日期
    getNowFormatDate () {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear() - 1;
      // var month = date.getMonth() + 1;
      // var strDate = date.getDate();
      // if (month >= 1 && month <= 9) {
      //     month = "0" + month;
      // }
      // if (strDate >= 0 && strDate <= 9) {
      //     strDate = "0" + strDate;
      // }
      // var currentdate = year + seperator1 + month + seperator1 + strDate;
      return year;
    },

    //千分化金额
    setMoneyFormat (num) {
      let data = Number(num);
      if (data > 0) {
        return (data.toFixed(2) + "").replace(
          /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
          "$&,"
        );
      } else {
        return 0;
      }
    },

    //初始化地图
    initChart () {
      let that = this;
      let chart = echarts.init(this.$refs.myEchart);
      window.onresize = echarts.init(this.$refs.myEchart).resize;
      // 把配置和数据放这里
      var option = this.option;
      chart.setOption({
        backgroundColor: "#fff",
        // tooltip: {
        //   trigger: "item",
        //   formatter: function(params) {
        //     var myseries = option;
        //     for (var i = 0; i < myseries.length; i++) {
        //       if (params.name == myseries[i].name) {
        //         var res = params.name + "<br/>";
        //         res +=
        //           "总发放金额" + " : " + myseries[i].value + "（元）" + "</br>";
        //         res +=
        //           "爱眼执行机构数量" +
        //           " : " +
        //           myseries[i].hospital +
        //           "（家）" +
        //           "</br>";
        //         res +=
        //           "总救助数量" +
        //           " : " +
        //           myseries[i].help_people +
        //           "（粒）" +
        //           "</br>";
        //       }
        //     }
        //     return res;
        //   }
        // },

        dataRange: this.dataRangeData,

        series: [
          {
            type: "map",
            mapType: "china",
            // zoom: 1.2,
            // mapLocation: {
            //   y: 100
            // },
            hoverAnimation: false,
            data: option,
            nameMap: this.nationName,
            // label: {
            //   normal: {
            //     formatter: function(params) {
            //       if (params.name == "中国") {
            //         return params.name;
            //       } else {
            //         return "";
            //       }
            //     }
            //   },
            //   emphasis: { show: false }
            // },
            itemStyle: {
              normal: { label: { show: true }, areaColor: "#fff" },
              emphasis: {},
              silent: true
            }
          }
        ]
      });
      //去掉鼠标经过的背景颜色
      chart.on("mouseover", function (param) {
        if (param.value != undefined) {
          chart.dispatchAction({
            type: "downplay"
          });
        }
      });
    },

    //跳转捐赠页面
    goDonation () {
      this.$router.push({ name: "donationIndex" });
    }
  },
  watch: {
    webData: {
      handler (val) {
        if (val) {
          this.webInfo = val;
        }
      },
      immediate: true
    }
  },

  computed: {
    optionSingleHeight () {
      return {
        singleHeight: 0,
        limitMoveNum: 2 // 开始无缝滚动的数据量 this.dataList.length
      };
    },
    webData () {
      let info = this.$store.state.web_info;
      return info;
    }
  }
};
</script>
<style lang="scss" scoped>
#app-print {
  width: 100%;
  margin-bottom: 20px;
}
#chartdiv {
  width: 100%;
  height: 500px;
}

.print-box {
  width: 1300px;
  margin: 0 auto;
  .print-top {
    position: relative;
    > h3 {
      font-size: 30px;
      color: #000;
      font-weight: normal;
      padding: 14px 0;
    }
    .border-box {
      width: 1300px;
      height: 1px;
      border: 1px solid #c30d23;
      border-bottom: 3px solid #c30d23;
    }
  }
  .print-bottom {
    padding-top: 18px;
    display: flex;
    justify-content: space-between;
    .print-left {
      animation-delay: 0.5s;
      .map-box {
        width: 545px;
        height: 430px;
      }
    }
    .print-right {
      width: 660px;
      animation-delay: 1s;
      .r-top {
        .top-title {
          padding: 8px 0;
          display: flex;
          justify-content: space-between;
          .title-box {
            > span {
              font-size: 18px;
              color: #000;
              padding-right: 8px;
            }
            > i {
              font-style: normal;
              font-size: 14px;
              color: #999;
              line-height: 24px;
            }
          }
          > p {
            font-size: 14px;
            color: #000;
            line-height: 26px;
          }
        }
        > ul {
          display: flex;
          justify-content: space-between;
          padding-bottom: 10px;
          border-bottom: 1px dashed #eee;

          li {
            list-style: none;

            > b {
              font-size: 20px;
              color: #c30d23;
            }
            > span {
              font-size: 14px;
              color: #c30d23;
            }
            > p {
              font-size: 14px;
              color: #666;
              padding-top: 4px;
            }
          }
          .donate-list {
            width: 25%;
            > b {
              font-size: 20px;
              color: #c30d23;
            }

            > span {
              font-size: 14px;
              color: #c30d23;
            }
          }
          .donate-list:nth-of-type(1) {
            padding-left: 0px !important;
          }

          .donate-list:nth-of-type(4) {
            padding-right: 0px !important;
          }
        }
      }
      .r-bottom {
        padding-top: 30px;
        .b-top {
          display: flex;
          justify-content: space-between;
          color: #333;
          > h5 {
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 30px;
            letter-spacing: 0px;
            margin-bottom: 25px;
          }
          > p {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 30px;
            letter-spacing: 0px;
          }
        }
        .item_box {
          width: 100%;
          > li {
            display: flex;
            justify-content: space-between;
            color: #333;
            margin-bottom: 20px;
            > h5 {
              font-size: 16px;
              font-weight: normal;
              white-space: nowrop;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 40%;
            }
            > p {
              font-size: 16px;
              font-weight: normal;
              width: 30%;
            }
            > span {
              font-size: 14px;
              font-weight: normal;
              width: 100px;
            }
          }
        }
        .seamless-warp {
          overflow: hidden;
          height: 105px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/home_footprint.vue